const TEXT_COLOR_WHITE = "#FFF";
const TEXT_COLOR_BLACK = "#000";
const TEXT_COLOR_GREY = "#979797";
const GRADIENT_TEXT_COLOR_GREEN =
  "linear-gradient(90deg, #43FFBE 0.77%, #00CE87 99.1%)";
const GRADIENT_TEXT_COLOR_RED =
  "linear-gradient(270deg, #ff5858 6.7%, #ff7070 97.49%)";

const BORDER_COLOR_GREY = "#303435";
const BORDER_COLOR_GREY_2 = "#1C1F20";
const BACKGROUND_COLOR_BLACK = "#0F0F0F";
const BACKGROUND_COLOR_BLACK_1 = "#141517";
const BACKGROUND_COLOR_BLACK_2 = "#292929";
const BACKGROUND_COLOR_BLACK_3 = "#121415";
const BACKGROUND_COLOR_GREY = "#191B1D";
const BACKGROUND_COLOR_GREY_2 = "#6D6D6D";

export {
  TEXT_COLOR_WHITE,
  TEXT_COLOR_BLACK,
  GRADIENT_TEXT_COLOR_GREEN,
  BORDER_COLOR_GREY,
  BACKGROUND_COLOR_BLACK,
  BACKGROUND_COLOR_GREY,
  BACKGROUND_COLOR_BLACK_1,
  BACKGROUND_COLOR_BLACK_2,
  BACKGROUND_COLOR_GREY_2,
  TEXT_COLOR_GREY,
  GRADIENT_TEXT_COLOR_RED,
  BACKGROUND_COLOR_BLACK_3,
  BORDER_COLOR_GREY_2
};
